import React, { useEffect, useRef, useState } from 'react';

import { Autocomplete, TextField, Popper, Box } from '@mui/material';
/**
 * Description
 * @param {Object[]} buttons
 * @param {Function} buttons[].onClick
 * @param {string} buttons[].text
 * @param {React.Component} buttons[].icon
 * @param {Boolean} showAutoComplete
 * @param {Object} autoCompleteProps
 * @param {Object[]} autoCompleteProps.options
 * @param {Function} autoCompleteProps.getOptionLabel
 * @param {Function} autoCompleteProps.onChange
 * @param {Function} autoCompleteProps.onOpen
 * @param {Function} autoCompleteProps.onClose
 * @param {Function} autoCompleteProps.onReset
 * @param {Function} autoCompleteProps.renderOption
 * @param {Object} autoCompleteProps.sx
 * @param {Object} autoCompleteProps.style
 * @param {Function} autoCompleteProps.renderInput
 * @param {Function} autoCompleteProps.isOptionEqualToValue
 * @param {Function} autoCompleteProps.PopperComponent
 * @param {String} autoCompleteProps.noOptionsText
 * @param {String} autoCompleteProps.size
 * @param {Function} setIsOpenAutoComplete
 * @returns {JSX.Element}
 */

export const BottomBar = ({ buttons, showAutoComplete, autoCompleteProps }) => {
  const bottomBarRef = useRef(null);

  return (
    <div className="flex justify-center flex-col md:flex-row items-center  gap-2">
      {showAutoComplete && (
        <div className=" rounded-3xl">
          <Autocomplete {...autoCompleteProps} />
        </div>
      )}
      <div
        ref={bottomBarRef}
        className="flex-row flex gap-2 items-center overflow-x-auto sm:justify-center md:w-full w-screen  px-2  justify-normal"
      >
        {buttons?.map((button, index) => {
          return (
            <BottomBarButton key={index} onClick={button.onClick}>
              <div className="flex items-center text-nowrap gap-1">
                <div>{<button.icon color="#6b7280" size={15} />}</div>
                <div>{button.text}</div>
              </div>
            </BottomBarButton>
          );
        })}
      </div>
    </div>
  );
};

const BottomBarButton = ({ children, className, ...props }) => {
  return (
    <button
      {...props}
      className="bg-white shadow-md  flex items-center rounded-xl p-2 text-xs justify-center"
    >
      {children}
    </button>
  );
};
